import { render, staticRenderFns } from "./selectExhibition.vue?vue&type=template&id=66b4b286&scoped=true"
import script from "./selectExhibition.vue?vue&type=script&lang=js"
export * from "./selectExhibition.vue?vue&type=script&lang=js"
import style0 from "./selectExhibition.vue?vue&type=style&index=0&id=66b4b286&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b4b286",
  null
  
)

export default component.exports